import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

import ActivityNotes from 'components/ActivityNotes';

import { entitiesCleanUp as cleanStations } from 'state/actions/stations';

import { fetchEntities as fetchLogs } from 'state/actions/logs';
import { fetchEntities as fetchUsers } from 'state/actions/users';
import { useFormatMessage } from 'hooks';
import { parseEntityDataToComponents } from 'utils/schema';

import './index.scss';

const EntityProfile = ({
  entity,
  entityInfos,
  entitySchema,
  // contact,
  onActivityLogSubmitHandler,
  children,
}) => {
  const {
    i18nEntityName,
    // entitiesName,
    entityName,
    // contactEntitiesName,
    // PATH_ENTITIES,
  } = entityInfos;

  const { id } = entity;

  const { currentUserId, logs, users } = useSelector(
    (state) => ({
      currentUserId: state.auth.userData.id,
      logs: state.logs.data
        .filter((log) => log.entityId === id)
        .sort(
          (a, b) =>
            new Date(a.createdAt).getTime() < new Date(b.createdAt).getTime()
        ),
      users: state.users.data,
      // stations: state.stations.data,
      // stationData: state.stationsData.data,
      // lastStatus: state.stationsData.lastStatus,
      // lastDataIsLoading: state.stationsData.lastDataIsLoading,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchLogs());
    return () => dispatch(cleanStations());
  }, [dispatch]);

  const usersDictionary = users.reduce((acc, user) => {
    const userId = user.id;
    acc[userId] = user;
    return acc;
  }, {});
  const logsWithAuthor = logs.map((log) => {
    const logWithAuthor = {
      ...log,
      author: usersDictionary[log.authorId],
    };
    return logWithAuthor;
  });

  const block = entitySchema.blocks[0];
  const options = { i18nEntityName };
  const componentsBlock = parseEntityDataToComponents(entity, block, options);

  return (
    <div className="columns">
      <div className="column ">
        <div className="block station-profile-block">
          <header className="card-header">
            <h4 className="title is-4">
              <span className="icon">
                <i className="mdi mdi-information-outline default" />
              </span>
              &nbsp;{useFormatMessage(`${i18nEntityName}.info`)}
            </h4>
          </header>
          <div className="card-content">{componentsBlock}</div>
        </div>

        {children}
        {/* <div className="block station-profile-block">
          <header className="card-header">
            <h4 className="title is-4">
              <span className="icon">
                <i className="mdi mdi-traffic-light default" />
              </span>
              &nbsp;{useFormatMessage(`${i18nEntityName}.status`)}
            </h4>
          </header>
          <div className="card-content">{statusDataComponent}</div>
        </div>

        <div className="block station-profile-block">
          <header className="card-header">
            <h4 className="title is-4">
              <span className="icon">
                <i className="mdi mdi-calendar-text-outline default" />
              </span>
              &nbsp;{useFormatMessage(`${i18nEntityName}.versions`)}
            </h4>
          </header>
          <div className="card-content">{versionDataComponents}</div>
        </div>

        <div className="block station-profile-block">
          <header className="card-header">
            <h4 className="title is-4">
              <span className="icon">
                <i className="mdi mdi-satellite-variant default" />
              </span>
              &nbsp;{useFormatMessage(`${i18nEntityName}.satellite`)}
            </h4>
          </header>
          <div className="card-content">{satelliteDataComponents}</div>
        </div>

        <div className="block station-profile-block">
          <header className="card-header">
            <h4 className="title is-4">
              <span className="icon">
                <i className="mdi mdi-phone-outline default" />
              </span>
              &nbsp;{useFormatMessage(`${i18nEntityName}.SIM`)}
            </h4>
          </header>
          <div className="card-content">{phoneDataComponents}</div>
        </div>

        <div className="block station-profile-block">
          <header className="card-header">
            <h4 className="title is-4">
              <span className="icon">
                <i className="mdi mdi-thermometer-lines default" />
              </span>
              &nbsp;{useFormatMessage(`${i18nEntityName}.measures`)}
            </h4>
          </header>
          <div className="card-content">
            {CONSTANTS.STATION_KEYS.MEASURES.map((measureKey) => {
              return (
                <div className="is-flex" key={measureKey}>
                  <input
                    type="checkbox"
                    defaultChecked={entity[measureKey]}
                    disabled
                  />
                  <label>
                    &nbsp;{useFormatMessage(`${i18nEntityName}.${measureKey}`)}
                  </label>
                </div>
              );
            })}
          </div> */}
        {/* </div> */}
        <ActivityNotes
          onSubmit={onActivityLogSubmitHandler}
          logs={logsWithAuthor}
          id={id}
          currentUserId={currentUserId}
          entityName={entityName}
        />
      </div>
    </div>
  );
};

// EntityProfile.propTypes = {
//   entity: PropTypes.object().isRequired(),
// };

export default EntityProfile;
